import { useContext, useEffect, useState } from "react";
import Slider from "react-slick";
import { services } from "../data/siteContent";
import { AppContext } from "../App";

export default function HomeServicesContent() {
  const appContext = useContext(AppContext);
  const [mobileIndex, setMobileIndex] = useState(0);

  useEffect(() => {
    const interval = window.setInterval(() => {
      setMobileIndex((current) => (current + 1) % services.length);
    }, 2800);

    return () => {
      window.clearInterval(interval);
    };
  }, []);

  const sliderSettings = {
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3500,
    centerMode: true,
    centerPadding: "0",
    dots: true,
    infinite: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    slidesToScroll: 1,
    slidesToShow: 3,
    speed: 650,
    swipeToSlide: true,
    cssEase: "ease-in-out",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
          centerPadding: "0",
          centerMode: true,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
          centerMode: true,
        },
      },
    ],
  };

  const activeMobileService = services[mobileIndex];

  return (
    <section className="ags-home-services-section">
      <div className="container">
        <div className="row align-items-end mb-4">
          <div className="col-lg-7" data-aos="fade-right">
            <p className="ags-section-kicker mb-3">Core Services</p>
            <h2 className="main-section-title mb-3">
              Geospatial services designed to move projects with confidence
            </h2>
          </div>
          {/* <div className="col-lg-5" data-aos="fade-left">
            <p className="text-muted mb-0">
              The homepage keeps this section intentionally concise. Each service
              appears as a visual story card with the description layered over
              the image area for a clean, high-end presentation.
            </p>
          </div> */}
        </div>
      </div>

      <div className="d-none d-md-block">
        <div className="container">
          <div className="ags-services-carousel-wrap" data-aos="fade-up">
            <Slider {...sliderSettings}>
              {services.map((service) => (
                <div key={service.slug} className="ags-slide-shell">
                  <div
                    className={`ags-service-slide ags-visual-${service.visual}`}
                    style={{ backgroundImage: `url(${service.image})` }}
                    role="button"
                    tabIndex="0"
                    onClick={() =>
                      appContext.navTo({
                        item: "services",
                        subItem: service.slug,
                      })
                    }
                  >
                    <div className="ags-service-slide-overlay">
                      <span className="ags-service-chip">AGS Service</span>
                      <h3 className="font-bold text-white mb-2">
                        {service.title}
                      </h3>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>

      <div
        className="d-block d-md-none ags-mobile-service-viewport"
        data-aos="fade-up"
      >
        <div className="ags-mobile-service-stage">
          <div
            key={activeMobileService.slug}
            className="ags-mobile-service-card"
            style={{ backgroundImage: `url(${activeMobileService.image})` }}
            role="button"
            tabIndex="0"
            onClick={() =>
              appContext.navTo({
                item: "services",
                subItem: activeMobileService.slug,
              })
            }
          >
            <div className="ags-mobile-service-overlay">
              <span className="ags-service-chip">AGS Service</span>
              <h3 className="font-bold text-white mb-2">
                {activeMobileService.title}
              </h3>
              <p className="text-white-50 mNoMargin">
                {activeMobileService.shortDescription}
              </p>
            </div>
          </div>
        </div>

        <div className="ags-mobile-service-dots">
          {services.map((service, index) => (
            <button
              key={service.slug}
              type="button"
              className={`ags-mobile-service-dot ${
                index === mobileIndex ? "active" : ""
              }`}
              onClick={() => setMobileIndex(index)}
              aria-label={`Show ${service.title}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
